import jsPDF from 'jspdf';
import { surveySteps } from '../Survey/Questions/Questions'; // Adjust the import path as needed

const generatePDF = (answers, title = 'Survey Answers') => {
  const doc = new jsPDF();

  doc.setFontSize(16);
  doc.text(title, 10, 10);

  let yOffset = 20;
  const pageWidth = 180; // Width of the PDF page in mm
  const lineHeight = 7; // Height of each line in mm

  const splitTextAndAddToDoc = (text, x, y) => {
    const lines = doc.splitTextToSize(text, pageWidth);
    lines.forEach((line, i) => {
      doc.text(line, x, y + i * lineHeight);
    });
    return y + lines.length * lineHeight;
  };

  // Ensure steps are in the correct order based on surveySteps
  surveySteps.forEach(step => {
    const stepTitle = step.stepTitle;
    const stepAnswers = answers[stepTitle];

    if (stepAnswers) {
      // Add separator line
      doc.setDrawColor(0); // Set color to black
      doc.setLineWidth(0.5);
      doc.line(10, yOffset, 200, yOffset);
      yOffset += 5;

      // Add step title in bold
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      yOffset = splitTextAndAddToDoc(stepTitle.replace(/_/g, ' '), 10, yOffset);
      yOffset += 5;

      // Add questions and answers in normal font
      doc.setFont('helvetica', 'normal');
      Object.entries(stepAnswers).forEach(([question, answer]) => {
        doc.setFontSize(12);
        yOffset = splitTextAndAddToDoc(`${question.replace(/_/g, ' ')}:`, 10, yOffset);
        yOffset += 5;
        yOffset = splitTextAndAddToDoc(`${typeof answer === 'object' ? JSON.stringify(answer) : answer}`, 10, yOffset);
        yOffset += 10;

        if (yOffset > 280) {
          doc.addPage();
          yOffset = 10;
        }
      });

      yOffset += 10;
    }
  });

  doc.save(`${title}.pdf`);
};

export default generatePDF;